/* eslint-disable */
import { gsap } from 'gsap'
import * as polylabel from 'polylabel'
import '../map-fontaine.js'

export default {
  init() {
    var responseData = undefined
    var mapboxContainer = document.getElementById('map')

    if (mapboxContainer) {
      $.ajax({
        url: wp.ajaxurl,
        type: 'POST',
        data: {
          action: 'get_invoices',
        },
      }).done(function (response) {
        responseData = response
        console.log(response)
        response.forEach(function (item) {
          map.on('click', 'communes', function (e) {
            if (item.code === e.features[0].properties.code) {
              new mapboxgl.Popup()
                .setLngLat(e.lngLat)
                .setHTML(
                  '<div style="display: flex; flex-direction: column;"><div style="margin-bottom: 5px; font-weight: bold; font-size: 18px; line-height: 22px; color:#012657;">' +
                  item.name +
                  '</div><div style="font-size: 11px; line-height: 16px; color: #455A85;">' +
                  item.code +
                  '</div><div style="margin-top: 17px; display: flex; align-items:center;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><rect width="16" height="16" fill="#009ee0" opacity="0"/><path d="M10.667,12l2.667-3.333h-2V4H10V8.667H8Z" transform="translate(-2.667 -1.333)" fill="#009ee0"/><path d="M14,15.667H3.333V11H2v4.667A1.335,1.335,0,0,0,3.333,17H14a1.335,1.335,0,0,0,1.333-1.333V11H14Z" transform="translate(-0.667 -3.667)" fill="#009ee0"/></svg><div style="margin-left: 6px; font-size: 14px; line-height: 16px; color:#455A85;"><a href="' +
                  item.file +
                  '" target="_blank">Modèle de facture</a></div></div></div>'
                )
                .addTo(map)
            }
          })
        })
      })

      var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

      mapboxgl.accessToken =
        'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2tlMmhob3hkMDlibzMxbjcwM2x2bWRnbiJ9.epIHoVvz_0DGDq39sSzZiA'
      var map = new mapboxgl.Map({
        container: mapboxContainer,
        center: [6.166667, 49.133333],
        zoom: 8,
        maxZoom: 15,
        minZoom: 9,
        style: 'styles/web-idemapbox://a/clgp7ukvg00h501pegqtq1w7l',
      })

      // Holds visible airport features for filtering
      var communes = []

      // Create a popup, but don't add it to the map yet.
      var popup = new mapboxgl.Popup({
        closeButton: false,
      })

      var filterEl = document.getElementById('feature-filter')
      var listingEl = document.getElementById('feature-listing')

      function renderListings(features) {
        var empty = document.createElement('p')
        // Clear any existing listings
        listingEl.innerHTML = ''

        features.sort((a, b) =>
          a.properties.nom.localeCompare(b.properties.nom)
        )

        if (features.length) {
          features.forEach(function (feature) {
            var prop = feature.properties
            var item = document.createElement('a')
            item.href = '#'
            item.textContent = prop.nom + ' (' + prop.code + ')'

            item.addEventListener('click', function (e) {
              e.preventDefault()
              map.flyTo({
                zoom: 10,
                speed: 0.5,
                center: polylabel(feature.geometry.coordinates, 1.0),
                essential: true,
              })

              var file
              if (responseData != undefined) {
                responseData.forEach(function (item) {
                  if (item.code === prop.code) {
                    file = item.file
                  }
                })

                if (file != undefined) {
                  var html =
                    '<div style="display: flex; flex-direction: column;"><div style="margin-bottom: 5px; font-weight: bold; font-size: 18px; line-height: 22px; color:#012657;">' +
                    feature.properties.nom +
                    '</div><div style="font-size: 11px; line-height: 16px; color: #455A85;">' +
                    feature.properties.code +
                    '</div><div style="margin-top: 17px; display: flex; align-items:center;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><rect width="16" height="16" fill="#009ee0" opacity="0"/><path d="M10.667,12l2.667-3.333h-2V4H10V8.667H8Z" transform="translate(-2.667 -1.333)" fill="#009ee0"/><path d="M14,15.667H3.333V11H2v4.667A1.335,1.335,0,0,0,3.333,17H14a1.335,1.335,0,0,0,1.333-1.333V11H14Z" transform="translate(-0.667 -3.667)" fill="#009ee0"/></svg><div style="margin-left: 6px; font-size: 14px; line-height: 16px; color:#455A85;"><a href="' +
                    file +
                    '" target="_blank">Modèle de facture</a></div></div></div>'
                } else {
                  var html =
                    '<div style="display: flex; flex-direction: column;"><div style="margin-bottom: 5px; font-weight: bold; font-size: 18px; line-height: 22px; color:#012657;">' +
                    feature.properties.nom +
                    '</div><div style="font-size: 11px; line-height: 16px; color: #455A85;">' +
                    feature.properties.code +
                    '</div></div></div>'
                }
              }

              popup
                .setLngLat(polylabel(feature.geometry.coordinates, 1.0))
                .setHTML(html)
                .addTo(map)
            })

            listingEl.appendChild(item)
          })

          // Show the filter input
          filterEl.parentNode.style.display = 'block'
        } else if (features.length === 0) {
          empty.textContent = 'Aucun résultat'
          listingEl.appendChild(empty)
        }
      }

      function normalize(string) {
        return string.trim().toLowerCase()
      }

      function getUniqueFeatures(array, comparatorProperty) {
        var existingFeatureKeys = {}
        var uniqueFeatures = array.filter(function (el) {
          if (existingFeatureKeys[el.properties[comparatorProperty]]) {
            return false
          } else {
            existingFeatureKeys[el.properties[comparatorProperty]] = true
            return true
          }
        })

        return uniqueFeatures
      }

      map.on('load', function () {
        map.flyTo({
          zoom: 10,
          speed: 0.5,
          center: [6.166667, 49.133333],
          essential: true,
        })

        map.addSource('states', {
          type: 'geojson',
          data: '/app/themes/le-serm/resources/assets/communes.json',
        })

        map.addLayer({
          id: 'communes',
          type: 'fill',
          source: 'states',
          paint: {
            'fill-color': 'rgba(0, 158, 224, 1)',
            'fill-outline-color': 'rgba(1, 38, 87, 1)',
            'fill-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              8,
              0.6,
              14,
              0.05,
            ],
          },
        })

        map.on('mouseenter', 'communes', function () {
          map.getCanvas().style.cursor = 'pointer'
        })

        map.on('mouseleave', 'communes', function () {
          map.getCanvas().style.cursor = ''
        })

        map.on('moveend', function () {
          var features = map.queryRenderedFeatures({ layers: ['communes'] })

          if (features) {
            var uniqueFeatures = getUniqueFeatures(features, 'nom')
            renderListings(uniqueFeatures)

            // Clear the input container
            filterEl.value = ''

            // Store the current features in sn `communes` variable to
            // later use for filtering on `keyup`.
            communes = uniqueFeatures
          }
        })

        filterEl.addEventListener('keyup', function (e) {
          var value = normalize(e.target.value)

          // Filter visible features that don't match the input value.
          var filtered = communes.filter(function (feature) {
            var name = normalize(feature.properties.nom)
            var code = normalize(feature.properties.code)
            return name.indexOf(value) > -1 || code.indexOf(value) > -1
          })

          // Populate the sidebar with filtered results
          renderListings(filtered)

          // Set the filter to populate features into the layer.
          // if (filtered.length) {
          //   map.setFilter('airport', [
          //   'match',
          //   ['get', 'abbrev'],
          //   filtered.map(function (feature) {
          //     return feature.properties.abbrev;
          //   }),
          //   true,
          //   false
          //   ]);
          //   }
        })

        renderListings([])
      })
    }

    $('[data-fancybox="gallery"]').fancybox({
      touch: false,
      loop: true,
      thumbs: {
        autoStart: true,
      },

      afterClose: function (instance, slide) {
        $('.single-product-slider').slick('slickGoTo', slide.index, true)
      },
    })

    var slider = $('.single-product-slider').slick({
      prevArrow: $('.previous-nav > .slick-prev'),
      nextArrow: $('.next-nav > .slick-next'),
      infinite: true,
      arrows: true,
      speed: 800,
      slidesToShow: 1,
      asNavFor: '.single-product-image-thumbs',
    })

    var sliderThumbs = $('.single-product-image-thumbs').slick({
      infinite: true,
      arrows: false,
      speed: 800,
      slidesToShow: 10,
      // slidesToScroll: 10,
      variableWidth: true,
      focusOnSelect: true,
      asNavFor: '.single-product-slider',
    })

    // Navigation - navbar primary
    const dropdowns = document.querySelectorAll(
      '#menu-navbar > .menu-item-has-children'
    )
    const submenu = document.getElementById('submenu')

    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('click', function (e) {
        e.preventDefault()

        let targetId = e.target.parentNode.getAttribute('id')
        let targetElement = submenu.querySelector('.' + targetId)
        let submenuItems = submenu.querySelectorAll('.main-menu > li')

        submenuItems.forEach(function (submenuItem) {
          if (!submenuItem.classList.contains(targetId)) {
            submenuItem.style.display = 'none'
          } else {
            submenuItem.style.display = 'block'
            submenuItem.querySelector('a').style.display = 'none'
          }
        })

        if (
          !this.classList.contains('is-open') &&
          document.body.classList.contains('menu-is-open')
        ) {
          dropdowns.forEach(function (dropdown) {
            if (dropdown.classList.contains('is-open')) {
              dropdown.classList.toggle('is-open')
            }
          })

          document.body.classList.toggle('menu-is-open')
          submenu.classList.toggle('is-visible')
        }

        document.body.classList.toggle('menu-is-open')
        dropdown.classList.toggle('is-open')
        submenu.classList.toggle('is-visible')
      })
    })

    // Navigation - navbar secondary
    const navbarSecondary = document.querySelector('#navbar-secondary')

    navbarSecondary.addEventListener('click', function (e) {
      if (this.classList.contains('collapsed')) {
        if (!this.classList.contains('opened')) {
          e.preventDefault()
          e.stopPropagation()
          this.classList.add('opened')
        } else {
          this.classList.remove('opened')
        }
      }
    })

    let mapOverlay = document.querySelector('.map-overlay')
    if (mapOverlay) {
      let toggleMenuMap = document.querySelector('.toggleMenumap')
      toggleMenuMap.addEventListener('click', (e) => {
        e.preventDefault()

        mapOverlay.classList.toggle('closed')
      })
    }

    $('form.header-form').submit(function (e) {
      e.preventDefault()

      let log = $(this).find('input[name=login]').val()
      let pwd = $(this).find('input[name=password]').val()

      jQuery.post(
        '/wp/wp-admin/admin-ajax.php',
        {
          action: 'mon_action',
          log,
          pwd,
        },
        function (response) {
          if (!response.success) {
            $('form.header-form .form-error').html(response.message)
          } else if (response.success) {
            document.location.href = response.url
          }
        }
      )
    })

    let menuMobileLinks = document.querySelectorAll('.nav-mobile > ul > li.menu-item-has-children');

    menuMobileLinks.forEach(function (item) {
      let link = item.querySelector('a');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let submenu = e.target.parentNode.children[1]

        if (submenu.style.display === "block") {
          submenu.style.display = 'none'
        } else {
          submenu.style.display = 'block'
        }
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js